import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  "error-layout": defineAsyncComponent(() => import("/app/layouts/error-layout.vue").then(m => m.default || m)),
  "health-layout": defineAsyncComponent(() => import("/app/layouts/health-layout.vue").then(m => m.default || m)),
  "qr-code-layout": defineAsyncComponent(() => import("/app/layouts/qrCode-layout.vue").then(m => m.default || m))
}